import script from "./productInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./productInfo.vue?vue&type=script&setup=true&lang=js"

import "./productInfo.vue?vue&type=style&index=0&id=47e5e7bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e5e7bb"]])

export default __exports__